import React from 'react';
import { daoGet, daoPost, daoPut } from 'mrf/Dao';
import Button from './Button';
import { DialogActions, DialogContent, DialogTitle } from './Dialog';
import { formPromptMessage, FormWrapper, mrfErrorValidationHandler } from './FormCRUD';
import Modal from './Modal';
import { Unflatten } from 'mrf/redux/Mapper';
import { useTranslation } from 'react-i18next';
import { useFormDataSelector } from 'mrf/redux/ReduxHelper';
import { generateHtmlId } from 'mrf/utils/StringGenerators';
import notification, { TYPE } from 'mrf/utils/notification';

export default function DialogForm({
    title,
    context,
    submitCb,
    children,
    endpoint,
    getEndpoint,
    descriptor,
    method,
    saveLabel = 'Save',
    cancelLabel = "Cancel", 
    handleCancel, 
    handleSave,
    map = (i) => i,
    ...props
}) {
    const { t } = useTranslation();
    const data = useFormDataSelector(context);

    const handleClose = () => {
        if (window.confirm(t(formPromptMessage))) {
            context.close();
        }
    };

    handleCancel = handleCancel ?? handleClose;
    
    const submit = async (action) => {
        try {
            let ret;

            const data2 = { ...data };
            delete data2._meta;

            if (method === 'POST') {
                ret = await daoPost(endpoint, map(Unflatten(data2, descriptor)), action);
                if(ret?.message != null){
                    notification({ type: TYPE.SUCCESS, message: ret?.message });
                }
            } else if (method === 'PUT') {
                ret = await daoPut(endpoint, map(Unflatten(data2, descriptor)), action);
                if(ret?.message != null){
                    notification({ type: TYPE.SUCCESS, message: ret?.message });
                }
            }

            if (ret?.id) {
                return await daoGet(`${endpoint ?? getEndpoint}/${ret?.id}`);
            }

            // dispatch(deleteFormAction(resource + 'Errors'));
        } catch (e) {
            console.error(e);
            // const errors = {};

            // for (const field in e?.errors ?? []) {
            //     if (e.errors.hasOwnProperty(field)) {
            //         const components = field.split('.');
            //         const parts = components[0].split('[');
            //         if (parts.length > 1) {
            //             if (!errors[parts[0]]) {
            //                 errors[parts[0]] = {};
            //             }

            //             const idx = Number(parts[1].slice(0, -1));
            //             if (!errors[parts[0]][idx]) {
            //                 errors[parts[0]][idx] = {};
            //             }

            //             if (components.length === 1) {
            //                 errors[parts[0]][idx].msg = e.errors[field];
            //             } else {
            //                 errors[parts[0]][idx][components[1]] = e.errors[field];
            //             }
            //         } else {
            //             errors[field] = e.errors[field];
            //         }
            //     }
            // }

            // e.errors = errors;
            // setErrors({ ...e, _execute: action === 'execute' });
            throw e;
        }
    };

    const defaultSubmit = async (e) => {
        e.preventDefault();

        try {
            // clearTimeout(bufferedTimeout);
            const ret = await submit('execute');

            await submitCb?.(ret);
            context.close();

            // if (id) {
            //     resourceGetObject(dispatch, resource, `${endpoint}/${id}`, undefined, descriptor);
            //     alert(t('Object edited successfully!'));
            // } else {
            //     // resourceGetList({ dispatch, resource, endpoint, query: {}, sorter: SortSequence, descriptor });
            //     alert(t('Object added successfully!'));
            // }
        } catch (e) {
            console.error(e);
            mrfErrorValidationHandler(e, context);
        }
    };

    const handleSubmit = handleSave ?? defaultSubmit;

    const htmlId = generateHtmlId('button_save', title);

    return (
        <Modal modal={context.isOpen} close={handleClose} {...props}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <FormWrapper context={context} promptCondition={context.isOpen} children={children} />
            </DialogContent>
            <DialogActions>
                <Button htmlId={htmlId} color='primary' onClick={handleSubmit}>
                    {saveLabel}
                </Button>
                <Button color='secondary' type='button' onClick={handleCancel}>
                    {cancelLabel}
                </Button>
            </DialogActions>
        </Modal>
    );
}
